module.exports = __webpack_public_path__ + "static/img/img_shop_banner.66b3a0cb.png";